import { render, staticRenderFns } from "./kirbylink.vue?vue&type=template&id=029743d2"
import script from "./kirbylink.vue?vue&type=script&lang=js"
export * from "./kirbylink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports